import * as React from 'react';
import { SvgIcon } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import FaceIcon from '@material-ui/icons/Face';
import KitchenIcon from '@material-ui/icons/Kitchen';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import WebIcon from '@material-ui/icons/Web';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import LinkIcon from '@material-ui/icons/Link';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import ReceiptIcon from '@material-ui/icons/Receipt';
import RoomIcon from '@material-ui/icons/Room';
import SettingsIcon from '@material-ui/icons/Settings';
import StorefrontIcon from '@material-ui/icons/Storefront';
import PanToolIcon from '@material-ui/icons/PanTool';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PointOfSaleIcon from '@material-ui/icons/Receipt';
import EventNoteIcon from '@material-ui/icons/EventNote';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import TableChartIcon from '@material-ui/icons/TableChart';
import { RouteProps } from 'react-router-dom';
import {
  Customers,
  Deliveries,
  ExternalOrders,
  PekingExternal,
  StreetFoodExternal,
  Integrations,
  Orders,
  Reservations,
  Settings,
  Shops,
  Website,
  Preparations,
  Dashboard,
  Menus,
  MenuManagement,
  JobTypes,
  Locations,
  Report,
  TableBoard,
  TillReadings,
} from 'views';

interface SubPage {
  path: string;
  headerTitle: string;
  icon: typeof SvgIcon;
  searchTitle: string;
}

// Children not supported by AppLayout
export interface AppRouteProps extends Omit<RouteProps, 'children'> {
  path: string;
  headerTitle: string;
  sidebarName?: React.ReactNode;
  icon: typeof SvgIcon;
  subPages?: SubPage[];
  hideFromSidebar?: boolean;
}

export function getRoutes() {
  const routes: AppRouteProps[] = [
    {
      path: '/dashboard',
      headerTitle: 'Dashboard',
      icon: DashboardIcon,
      component: Dashboard,
    },
    {
      path: '/table-board',
      headerTitle: 'Table Board',
      icon: TableChartIcon,
      component: TableBoard,
    },
    {
      path: '/menu-sections',
      headerTitle: 'Menu',
      icon: MenuBookIcon,
      component: Menus,
    },
    {
      path: '/customers',
      headerTitle: 'Customers',
      icon: FaceIcon,
      component: Customers,
    },
    {
      path: '/orders',
      headerTitle: 'Orders',
      icon: ReceiptIcon,
      component: Orders,
    },
    {
      path: '/deliveries',
      headerTitle: 'Deliveries',
      icon: LocalShippingIcon,
      component: Deliveries,
    },
    {
      path: '/external-orders/peking',
      headerTitle: 'Peking External',
      icon: LinkIcon,
      component: PekingExternal,
    },
    {
      path: '/external-orders/street-food',
      headerTitle: 'SF External',
      icon: LinkIcon,
      component: StreetFoodExternal,
    },
    // Legacy route preserved for any deep links — uses the combined
    // view with the in-page shop toggle. Hidden from the sidebar so
    // it doesn't appear as a third entry.
    {
      path: '/external-orders',
      headerTitle: 'External Orders',
      icon: LinkIcon,
      component: ExternalOrders,
      hideFromSidebar: true,
    },
    {
      path: '/integrations',
      headerTitle: 'Integrations',
      icon: AccountTreeIcon,
      component: Integrations,
    },
    {
      path: '/reservations',
      headerTitle: 'Reservations',
      icon: EventNoteIcon,
      component: Reservations,
    },
    // X and Z readings. The screen was built on 2026-09-21 but was never put
    // in the sidebar, so no one could close a shift: 559 receipts were still
    // open when the EXO auditor was announced (2026-10-07).
    {
      path: '/till-readings',
      headerTitle: 'Till Readings',
      icon: PointOfSaleIcon,
      component: TillReadings,
    },
    {
      path: '/screens',
      headerTitle: 'Screens',
      icon: OndemandVideoIcon,
      component: MenuManagement,
      hideFromSidebar: true,
    },
    {
      path: '/shops',
      headerTitle: 'Shop',
      icon: StorefrontIcon,
      component: Shops,
      hideFromSidebar: true,
    },
    {
      path: '/job-type',
      headerTitle: 'Job Types',
      icon: KitchenIcon,
      component: JobTypes,
      hideFromSidebar: true,
    },
    {
      path: '/location',
      headerTitle: 'Location',
      icon: RoomIcon,
      component: Locations,
      hideFromSidebar: true,
    },
    {
      path: '/settings',
      headerTitle: 'Settings',
      icon: SettingsIcon,
      component: Settings,
    },
    {
      path: '/website',
      headerTitle: 'Website',
      icon: WebIcon,
      component: Website,
    },
    {
      path: '/preparation',
      headerTitle: 'Preparations',
      icon: PanToolIcon,
      component: Preparations,
      hideFromSidebar: true,
    },
    {
      path: '/report',
      headerTitle: 'Reports',
      icon: AssessmentIcon,
      component: Report,
    },
  ];

  return routes;
}
